<template>
  <el-upload :action="fileServer" :data="data" :multiple="false" :file-list="fileList" show-file-list list-type="picture" :on-remove="onRemove" :on-success="onSuccess">
    <el-button size="mini" type="primary">点击上传</el-button>
  </el-upload>
</template>

<script>
import { fls } from '@/config'

export default {
  name: 'image-upload-button',
  props: {
    property: { type: Object, required: true },
    path: { type: String, required: true }
  },
  data () {
    return {
      fileServer: `${fls}/files`,
      filePrefix: `${fls}/static-file`,
      data: {
        path: this.path
      },
      fileList: []
    }
  },
  watch: {
    'property.value': {
      handler: function (val) {
        if (val) {
          this.fileList = [{name: '已上传', url: this.filePrefix + val}]
        } else {
          this.fileList = []
        }
      },
      immediate: true
    }
  },
  methods: {
    onRemove () {
      this.property.value = ''
      this.fileList = []
      this.$emit('change')
    },
    onSuccess (res, info) {
      this.fileList = [{name: info.name, url: this.filePrefix + res.data}]
      this.property.value = res.data
      this.$emit('change')
    }
  }
}
</script>
